import { configUiPanel_mobile_vertical as  configUiPanel_default} from "src/library/minigame_client/ui/panel"

export let configUiPanel_desktop_horizontal = _.cloneDeep(configUiPanel_default);

const resourcesUiPanel_desktop_horizontal = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/common/minigames/sounds/btn_click",
            "res/common/minigames/sounds/play_click",
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/desktop_horizontal/panel/common.json",
            {name: "res/desktop_horizontal/panel/panel.json", rus: true},

            "res/desktop_horizontal/fonts/font_credits_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/arial_black_10_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_bet_total_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_bet_up_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_bet_over_desktop_horizontal.xml",
        ]
};


configUiPanel_desktop_horizontal.resources = resourcesUiPanel_desktop_horizontal;
configUiPanel_desktop_horizontal.packFolder = "panel_desktop_horizontal/";
configUiPanel_desktop_horizontal.sndBtnClick = "res/sounds/btn_click";
configUiPanel_desktop_horizontal.sndBtnPlay = "res/sounds/btn_click";
configUiPanel_desktop_horizontal.screenWidth = 1920;
configUiPanel_desktop_horizontal.screenHeight = 1080;
configUiPanel_desktop_horizontal.isMobileMode = false;                                // if false - not need res folders digital_panel
configUiPanel_desktop_horizontal.isAccumulateBetMode = true;                          // if false - not need res folders 2div, 2mul, clear, if true - not need light texture in folders bet, min_bet, max_bet
configUiPanel_desktop_horizontal.isNoMinMaxButtons = false;                           // if true - not need res folders min_bet, max_bet
configUiPanel_desktop_horizontal.isNoDivMulButtons = false;                           // if true - not need res folders 2div, 2mul
configUiPanel_desktop_horizontal.isHideTotalBet = false;                              // если нужно скрыть валюту и ставку и выводить ее иначе
configUiPanel_desktop_horizontal.isHideCurrencyCredits = false;                       // если нужно скрыть валюту кредитов
configUiPanel_desktop_horizontal.balanceTabPosition = {x: 692, y: 942};
configUiPanel_desktop_horizontal.buttonPlaceBetPosition = {x: 1793, y: 949};
configUiPanel_desktop_horizontal.buttonClearTotalBetPosition = {x: 1483, y: 949};
configUiPanel_desktop_horizontal.buttonDivPosition = {x: 1615, y: 834};
configUiPanel_desktop_horizontal.buttonMulPosition = {x: 1834, y: 835};
configUiPanel_desktop_horizontal.buttonMinPosition = {x: 1697, y: 864};
configUiPanel_desktop_horizontal.buttonMaxPosition = {x: 1697, y: 811};
configUiPanel_desktop_horizontal.widthTotalBetTextArea = 500;
configUiPanel_desktop_horizontal.widthCreditsTextArea = 332;
configUiPanel_desktop_horizontal.widthBetButtonTextArea = 183;                        // ширина области для вывода текста(для скалирования текста если не помещается)
configUiPanel_desktop_horizontal.lengthAreaForBetsButtons = 645;                      // ширина(высота) области для размещения кнопок ставок(скалирование кнопок для заполнения всей области)
configUiPanel_desktop_horizontal.lengthBetButton = 90;                                // ширина(высота) кнопки
configUiPanel_desktop_horizontal.offsetBetweenBetButtons = 2;                         // отступ между кнопками
configUiPanel_desktop_horizontal.startBetButtonsPos = {x: 1646, y: 710};              // координаты первой кнопки
configUiPanel_desktop_horizontal.isVerticallyDirection = true;                        // вертикально или горизонтально идут кнопки
configUiPanel_desktop_horizontal.labelCredits = {
    // pos: {x: 813, y: 973},
    pos: {x: 120, y: 30},
    font: {
        name: "font_credits_desktop_horizontal"
    }
};
configUiPanel_desktop_horizontal.labelCurrencyCredits = {
    pos: {x: 202, y: 94},
    font: {name: "arial_black_10_desktop_horizontal"}
};
configUiPanel_desktop_horizontal.labelTotalBet = {
    pos: {x: 1682, y: 974},
    font: {name: "font_bet_total_desktop_horizontal"}
};
configUiPanel_desktop_horizontal.labelCurrencyTotalBet = {
    pos: {x: 1765, y: 1041},
    font: {name: "arial_black_10_desktop_horizontal"}
};
configUiPanel_desktop_horizontal.labelBetButton = {
    pos: {x: 118, y: 29},
    font: {name: "font_bet_up_desktop_horizontal"}
};
configUiPanel_desktop_horizontal.labelBetLight = {
    pos: {x: 118, y: 29},
    font: {name: "font_bet_over_desktop_horizontal"}
};


//////////////////
// WEBPACK FOOTER
// ./cfg/desktop_horizontal/panel.es6
// module id = 39
// module chunks = 0